import Paginator from '../pagination/Paginator';
import Table from './Table';

const PageableTable = ({
  leftControl,
  loading,
  rows,
  columns,
  sortParams,
  onSortChange,
  onPageChange,
  onSelect,
  pageSize,
  setPageSize,
  selectedPage,
  setSelectedPage,
  totalCount,
}) => {
  const onPageChangeClient = ({ selected }) => {
    const offset = pageSize * selected;
    const limit = pageSize;

    if (onPageChange) {
      // perform server side paging
      onPageChange({ selected, offset, limit });
    }

    setSelectedPage(selected);
  };

  return (
    <div>
      <div className="mb-5 flex flex-wrap gap-3">
        {leftControl}
      </div>
      <div className="w-full flex flex-col max-h-[900px] shadow overflow-hidden border border-gray-200 sm:rounded-lg">
        <Table
          isStickyHeader={true}
          loading={loading}
          onSelect={onSelect}
          columns={columns}
          rows={rows}
          sortParams={sortParams}
          onSortChange={onSortChange}
        />
        <Paginator
          rowCount={totalCount}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onPageChange={onPageChangeClient}
          initialPage={1}
          selectedPage={selectedPage}
        />
      </div>
    </div>
  );
};

export default PageableTable;
